module.exports = {"530425001":"龙泉街道","530425002":"六街街道","530425100":"绿汁镇","530425201":"浦贝彝族乡","530425202":"十街彝族乡","530425203":"铜厂彝族乡","530425204":"小街乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530425.json
// module id = 2380
// module chunks = 0